import { Component, inject, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '@/app/core/auth-layout/service/layout.service';
import { ButtonModule } from 'primeng/button';
import { AuthService, CurrentUser, UserPreferences } from '@/app/features/authentication/services/auth.service';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ChangeDetectorRef } from '@angular/core';

import {
    ChangePasswordDialogComponent
} from '@/app/shared/components/dialogs/change-password/change-password-dialog.component';
import { UserSettingsDialogComponent } from '@/app/shared/components/dialogs/user-settings/user-settings-dialog.component';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule,  ButtonModule, ChangePasswordDialogComponent, UserSettingsDialogComponent, ToastModule, UserSettingsDialogComponent],
    providers: [MessageService],
    template: ` 
        <p-toast></p-toast>

        <pb-change-password-dialog
            [visible]="changePasswordDialogVisible"
            (visibleChange)="changePasswordDialogVisible = $event"
            (changeRequested)="onChangePassword($event)"
        ></pb-change-password-dialog>

        <pb-user-settings-dialog
            [visible]="userSettingsVisible"
            [preferences]="authService.userPreferences()"
            (visibleChange)="userSettingsVisible = $event"
            (saveRequested)="onUserSettingsSave($event)">
        </pb-user-settings-dialog>

    <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
        
        @if (authenticated()) {
            <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
        }
            <!--
            <svg
                class="app-logo"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 600 120"
                aria-label="MARKANT Bridge"
            >
                <text
                    x="300"
                    y="75"
                    text-anchor="middle"
                    font-family="Arial, Helvetica, sans-serif"
                    font-size="48"
                    font-weight="600"
                    fill="#f63b3b">
                    MARKANT Bridge
                </text>
            </svg>-->
        </div>

        <div class="layout-topbar-actions">

            <div class="layout-config-menu">
             <!--   <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                    <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
                </button>
                <div class="relative">
                    <button
                        class="layout-topbar-action layout-topbar-action-highlight"
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="animate-scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="animate-fadeout"
                        [hideOnOutsideClick]="true"
                    >
                        <i class="pi pi-palette"></i>
                    </button>
                    <app-configurator />
                </div>-->
            </div>

            <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                <i class="pi pi-ellipsis-v"></i>
            </button>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content">

                    @if (!authenticated() === true) {
                        <button pButton pRipple label="Sign In" (click)="login()" [rounded]="true" ></button>                        
                    } @else {
                        @if (authenticated() && currentUser; as user) {
                            <div class="topbar-user">
                                <i class="pi pi-user"></i>
                                <span>{{ user.given_name }} {{ user.family_name }}</span>
                            </div>
                        }
                        <p-button
                            label="User preferences"
                            icon="pi pi-key"
                            severity="primary"
                            (onClick)="onUserSettingsRequested()">
                        </p-button>

                        <button pButton pRipple label="Sign Out" (click)="logout()" [rounded]="true" ></button>
                    }

                </div>
            </div>
        </div>
    </div>`,
    styles: [
        `
           .layout-topbar-logo-container {
                min-width: 0;
                flex: 1 1 auto;
                overflow: hidden;
            }

            .app-logo {
                display: block;
                width: min(300px, 100%);
                height: auto;
                max-width: 100%;
            }

            @media (max-width: 600px) {
                    .app-logo {
                        display: none;
                    }
                }

            .topbar-user {
                display: inline-flex;
                align-items: center;
                gap: 0.75rem;
                margin-right: 1rem;
                line-height: 1;
                white-space: nowrap;
            }

            .topbar-user i {
                font-size: 1rem;
            }
        `
    ]
})
export class AppTopbar {
    items!: MenuItem[];

    router = inject(Router);

    layoutService = inject(LayoutService);

    changePasswordModel = {
        password: '',
        passwordConfirm: ''
    };

    readonly authService = inject(AuthService);
    private readonly messageService = inject(MessageService);
    private readonly cdr = inject(ChangeDetectorRef);

    readonly authenticated = this.authService.authenticatedSignal;

    readonly userPreferences = this.authService.userPreferences;

    readonly currentUser = this.authService.user;



    changePasswordDialogVisible = false;
    userSettingsVisible = false;

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({
            ...state,
            darkTheme: !state.darkTheme
        }));
    }

    logout(): void {
        this.authService.logout();
    }


    public async login(): Promise<void> {
        //this.authService.login();
        await this.router.navigate(['/login']);
    }

    public changePassword(): void {
        //
    }

    onChangePassword(password: string): void {

        this.authService
            .changeMyPassword({
                password,
            })
            .subscribe({

                next: () => {

                    this.messageService.add({
                        severity: 'success',
                        summary: 'Password changed',
                        detail:
                            'Your password has been changed successfully.',
                    });

                    this.changePasswordDialogVisible =
                        false;

                    this.cdr.detectChanges();

                },

                error: error => {

                    console.error(
                        'Failed to change password',
                        error,
                    );

                    this.messageService.add({
                        severity: 'error',
                        summary: 'Password change failed',
                        detail:
                            'Failed to change your password.',
                    });

                },

            });
    }

    onChangePasswordRequested(): void {
        this.changePasswordModel = {
            password: '',
            passwordConfirm: ''
        };

        this.changePasswordDialogVisible = true;
    }

    onUserSettingsRequested(): void {
        this.userSettingsVisible = true;
    }

    onUserSettingsSave(
        preferences: UserPreferences
    ): void {
        this.authService
            .updateUserPreferences(preferences)
            .subscribe({
                next: () => {
                    this.userSettingsVisible = false;
                },
                error: error => {
                    console.error(
                        'Failed to update user preferences.',
                        error,
                    );
                },
            });
    }

}
